const indexItems = [
  { title: '娱乐八卦全收录', count: '1,280篇', desc: '明星动态、恋情实锤、综艺名场面应有尽有', icon: 'ri-movie-line', color: 'bg-primary-100 text-primary-500' },
  { title: '社会热点追踪', count: '960篇', desc: '民生事件、社会新闻、热点话题深度解读', icon: 'ri-global-line', color: 'bg-accent-100 text-accent-500' },
  { title: '科技财经前沿', count: '750篇', desc: '互联网大事件、创投动态、科技新品速递', icon: 'ri-cpu-line', color: 'bg-secondary-100 text-secondary-500' },
  { title: '体育电竞专区', count: '680篇', desc: '赛事直击、选手动态、电竞圈大事件', icon: 'ri-gamepad-line', color: 'bg-primary-100 text-primary-500' },
  { title: '网红直播观察', count: '520篇', desc: '网红动态、直播翻车、带货内幕全揭露', icon: 'ri-live-line', color: 'bg-accent-100 text-accent-500' },
  { title: '影视综艺点评', count: '490篇', desc: '剧评影评、综艺分析、年度盘点与推荐', icon: 'ri-tv-line', color: 'bg-secondary-100 text-secondary-500' },
  { title: '美食旅游探秘', count: '380篇', desc: '探店测评、美食踩雷、旅游攻略精选', icon: 'ri-restaurant-line', color: 'bg-primary-100 text-primary-500' },
  { title: '吃瓜福利中心', count: '310篇', desc: '活动福利、积分兑换、限量好礼不停送', icon: 'ri-gift-2-line', color: 'bg-accent-100 text-accent-500' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          专题索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          按主题浏览所有内容，快速找到你感兴趣的吃瓜方向
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex items-start gap-4"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${item.color} group-hover:scale-110 transition-transform duration-300`}>
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap ml-2">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}